import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["addButton", "inlineForm", "titleInput", "iconPreview"]

  connect() {
    this.hideForm();
  }

  showForm(event) {
    event.preventDefault();
    this.addButtonTarget.classList.add('hidden');
    this.inlineFormTarget.classList.remove('hidden');
    this.titleInputTarget.focus();
  }

  hideForm() {
    this.addButtonTarget.classList.remove('hidden');
    this.inlineFormTarget.classList.add('hidden');
    this.titleInputTarget.value = '';
    this.resetIconUpload();
  }

  cancel(event) {
    event.preventDefault();
    this.hideForm();
  }

  save(event) {
    event.preventDefault();
    
    const title = this.titleInputTarget.value.trim();
    if (!title) {
      this.titleInputTarget.focus();
      return;
    }

    // Create new design stage element
    const newStage = this.createStageElement(title);
    
    // Get the stages list
    const stagesList = document.getElementById('design-stages-list');
    
    // Create a new divider
    const newDivider = document.createElement('div');
    newDivider.className = 'border-b border-gray-100 my-2 -mx-6';
    
    // Append the new stage and divider to the list
    stagesList.appendChild(newStage);
    stagesList.appendChild(newDivider);
    
    // Reset form
    this.hideForm();
  }

  createStageElement(title) {
    const li = document.createElement('li');
    li.className = 'design-phase-item';
    
    const link = document.createElement('a');
    link.href = '#';
    link.className = 'flex items-center text-gray-700 hover:text-pink transition-colors duration-200 py-2 px-3 rounded-md hover:bg-gray-50 h-25';
    
    // Default icon if no custom icon uploaded
    const iconSvg = `
      <svg class="h-5 w-5 mr-3 text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 9.563C9 9.252 9.252 9 9.563 9h4.874c.311 0 .563.252.563.563v4.874c0 .311-.252.563-.563.563H9.564A.562.562 0 019 14.437V9.564z"/>
      </svg>
    `;
    
    link.innerHTML = iconSvg + `<span class="text-sm font-medium">${title}</span>`;
    li.appendChild(link);
    
    return li;
  }

  resetIconUpload() {
    // Reset icon upload preview if exists
    if (this.hasIconPreviewTarget) {
      this.iconPreviewTarget.style.backgroundImage = '';
    }
    const fileInput = this.inlineFormTarget.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = '';
    }
  }

  previewIcon(event) {
    const file = event.target.files[0];
    if (file && this.hasIconPreviewTarget) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.iconPreviewTarget.style.backgroundImage = `url(${e.target.result})`;
      };
      reader.readAsDataURL(file);
    }
  }
}